var wFlag=window.innerWidth>750

// if(wFlag){
//     $('.box8Swiper').addClass('swiper-no-swiping')
// }

// const lenis = new Lenis({
//     lerp: 0.1, // 平滑度（越小越丝滑）默认0.1
// });

// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }

// requestAnimationFrame(raf);

$(()=>{
    var homeBanner = new Swiper('.newSwiper', {
        autoplay:{
            delay: 8000,
            //disableOnInteraction: false,
        },
        //autoplay:false,
        pagination: {
            el: '.newSwiper-pagination',
            clickable:true
        },
        navigation: {
            nextEl: '.newSwiper-button-next',
            prevEl: '.newSwiper-button-prev',
        },
        //  slider 的数量大于1时 loop
        loop:true
    })
    // 和loop 同步修改
    $('.newSwiper-button-prev').hide()
    $('.newSwiper-button-next').hide()
    
    new Swiper('.moveSwiper', {
        direction: 'vertical',
        autoplay:{
            delay: 2000,
            disableOnInteraction: false,
        },
        //autoplay:false,
        loop:true
    })

    //box2
    var swiperSlides = document.querySelectorAll('.box2Swiper .swiper-slide');
    new Swiper('.box2Swiper', {
        autoplay:{
            delay: 3000,
            // disableOnInteraction: false,
        },
        pagination: {
            el: '.box2Swiper-pagination',
            clickable:true
        },
        //  slider 的数量大于1时 loop
        loop:swiperSlides.length>1
    })

    //swiper
    $('.newS_butHover').hover(function(){
        $(this).css({background:'rgba(0,0,0,0.2)'})
        $(this).children('img').css({opacity:'1'})
    },function(){
        $(this).css({background:'none'})
        $(this).children('img').css({opacity:'0.6'})
    })

    var newH5Swiper = new Swiper('.newH5Swiper', {
        slidesPerView:1,
        centeredSlides:true,
        loop:true,
        pagination: {
            el: '.newH5Swiper-pagination',
            clickable:true
        },
        autoplay:{
            delay: 5000,
            disableOnInteraction: false,
        }, 
        on:{
            slideChangeTransitionEnd: function(){
                var index = this.realIndex
                if(wFlag){
                    //复原
                    $(`.b5Bar div`).find('.b5b_bg').css({filter:'brightness(0.4)'})
                    $(`.b5Bar div`).find('p').css({opacity:1})
                    $(`.b5Bar div`).find('span').css({width:'0%',transition:'width 0s',})
                    //设置
                    $(`.b5Bar div:nth-child(${index+1})`).find('.b5b_bg').css({filter:'brightness(1)'})
                    $(`.b5Bar div:nth-child(${index+1})`).find('p').css({opacity:0})
                    $(`.b5Bar div:nth-child(${index+1})`).find('span').css({width:'100%',transition:'width 5.3s linear'})
                }

                for(var i=0;i<$('.newH5Swiper .newH5_item video').length;i++){
                    if(i != $('.newH5Swiper .swiper-slide-active').index()){
                        $('.newH5Swiper .newH5_item video')[i].pause()
                        $('.newH5Swiper .swiper-slide-active')[0].children[0].children[0].play()
                        
                    }else{
                        $('.newH5Swiper .swiper-slide-active')[0].children[0].children[0].play()
                    }
                }
            },
        }
    })

    $('.b5Bar div').click(function(){
        var index = $(this).index()+1
        newH5Swiper.slideTo(index, 300)
    })

    new Swiper('.newH6swiper1', {
        speed:wFlag?14000:8000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          //waitForTransition: false,
        },
        slidesPerView :wFlag?5.5:1.5,
        loop:true
    })
    
    var box8Swiper = new Swiper('.box8Swiper', {
        autoplay:true,
        slidesPerView: wFlag?3:1,
        centeredSlides: true,
        loop:true,
        pagination: {
            el: '.newH8Swiper-pagination',
            clickable:true
        }
    })
    box8Swiper.slideTo(1, 0, false)
})